

exports.__esModule = true;

var _angular = require('angular');

var _squid = require('squid');

var _index = require('xo-models/src/onboard/index');

var _directive = require('components/xo-form-components/src/national-id-input/directive');

var _index2 = require('xo-models/src/frs/index');

var _logger = require('xo-beaver/dist/logger');

var _uiRouter = require('uiRouter');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _pxpExperimentConstants = require('./constants/pxpExperimentConstants');

var _pxpExperimentConstants2 = _interopRequireDefault(_pxpExperimentConstants);

require('../guest/onboardOptions/signup/directive');

require('components/xo-ui-components/src/tooltip/directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoGuestUpgradeInterstitial', {
    tag: 'xo-guest-upgrade-interstitial',
    template: _template2['default'],

    props: {
        token: {
            type: 'var'
        },
        parentModel: {
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            this.locale = _squid.$locale;
            this.flags = this.props.parentModel.flags;
            if (!this.flags) {
                _logger.$logger.info('WPS_interstitial_render_error');
                return _uiRouter.$state.go('checkout.genericError', { code: 'PAYMENT_ALREADY_DONE' });
            }
            this.flags.wpsInterstitial = true;
            this.flags.showMobileEmailSection = true;
            this.onboard = this.props.parentModel.onboard;
            this.frsContentKeys = {};

            // If US, then show new e-sign compliance experience
            // Submit button text changes and return to merchant msg above button
            // with user action 'continue'
            if (this.locale.country === 'US') {
                this.showNewSignupComplianceExp = true;
            }

            if (this.flags.freeReturnShippingOptInFlowApplicable) {
                var treatmentName = this.flags.freeReturnShippingApplicableTreatment;
                var treatmentContentKeys = _pxpExperimentConstants2['default'].test['frs_wps_optional'][treatmentName];
                this.frsContentKeys = treatmentContentKeys ? treatmentContentKeys : {};
            }
        },
        populate: function populate() {
            var _this = this;

            this.handleFrsContingency = function (message) {
                _logger.$logger.info('WPS_guest_upgrade_free_return_shipping_optin_' + message);
                _this.logFptiFrsError();
                return _uiRouter.$state.go('checkout.done');
            };

            this.handleFrsError = function (message, error) {
                _logger.$logger.info('WPS_guest_upgrade_free_return_shipping_optin_' + message, error);
                _this.logFptiFrsError();
                return _uiRouter.$state.go('checkout.done');
            };

            this.logFptiFrsError = function () {
                _logger.$logger.info('checkout_fpti', {
                    from: 'guest_upgrade_interstitial_frs_optin_flow',
                    to: 'process_frs_optin_user_failure'
                });
            };
        }
    },

    actions: {
        onSubmit: function onSubmit() {
            var _this2 = this;

            this.upgrade = new _index.$GuestUpgradeModel();

            this.upgrade.billing_address = this.onboard.billing_address;
            this.upgrade.user = this.onboard.user;
            this.upgrade.payerId = this.onboard.payerId;
            this.upgrade.transaction = this.onboard.transaction;
            this.upgrade.phone = this.onboard.phone;
            this.upgrade.nationalIdModel = _directive.$NationalIdModel.instance(this.props.token);
            this.upgrade.experienceChannel = 'HERMES';

            var isFrsOptInFlow = this.flags.freeReturnShippingOptInFlowApplicable;
            var isFrsActiveFlow = this.flags.freeReturnShippingOptInActiveFlow;

            return this.upgrade.save({

                data: this.upgrade.serialize(),

                success: function success() {
                    _angular.$rootScope.mode = 'signup';
                    _logger.$logger.info('WPS_guest_upgrade_success');
                    if (isFrsOptInFlow) {
                        _logger.$logger.info('checkout_fpti', {
                            from: 'guest_upgrade_interstitial_frs_optin_flow',
                            to: 'prepare_frs_optin_user'
                        });

                        // Opt in upgraded user for Free Return Shipping benefit
                        // Set whether FRS opt-in flow type is Active or Silent
                        var frsOptInModel = new _index2.$FreeReturnShippingOptInModel();

                        var frsOptInRequest = {
                            optInStatus: 'Y',
                            optInType: isFrsActiveFlow ? 'ACTIVE' : 'SILENT'
                        };

                        return frsOptInModel.save({
                            data: frsOptInRequest,
                            success: function success(optInResponse) {
                                // User is opted into FRS benefit and can request return shipping refund for eligible transactions.
                                _logger.$logger.info('WPS_guest_upgrade_free_return_shipping_optin_success');
                                _logger.$logger.info('checkout_fpti', {
                                    from: 'guest_upgrade_interstitial_frs_optin_flow',
                                    to: 'process_frs_optin_user_success'
                                });
                                return _uiRouter.$state.go('checkout.done');
                            },
                            contingencies: {
                                // In-context FRS opt-in failed. User needs to opt-in to FRS explicitly.
                                FRS_OPTIN_ERROR: function FRS_OPTIN_ERROR() {
                                    return _this2.handleFrsContingency('FRS_OPTIN_ERROR');
                                },
                                VALIDATION_ERROR: function VALIDATION_ERROR() {
                                    return _this2.handleFrsContingency('VALIDATION_ERROR');
                                },
                                DEFAULT: function DEFAULT() {
                                    return _this2.handleFrsContingency('UNHANDLED_CONTINGENCY');
                                }
                            },
                            validation: function validation(errorResponse) {
                                return _this2.handleFrsError('SERVICE_VALIDATION_ERROR', errorResponse);
                            },
                            error: function error(errorResponse) {
                                return _this2.handleFrsError('SERVICE_ERROR', errorResponse);
                            }
                        });
                    }
                    return _uiRouter.$state.go('checkout.done');
                },
                error: function error() {
                    _logger.$logger.info('WPS_guest_upgrade_failed_SERVICE_ERROR');
                    return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
                },
                contingencies: {
                    DOB_INVALID: function DOB_INVALID() {
                        _logger.$logger.info('WPS_guest_upgrade_failed_DOB_INVALID');
                        return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
                    },
                    NATID_INVALID: function NATID_INVALID() {
                        _logger.$logger.info('WPS_guest_upgrade_failed_NATID_INVALID');
                        return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
                    },
                    DEFAULT: function DEFAULT() {
                        _logger.$logger.info('WPS_guest_upgrade_failed_Unknown_contingency');
                        return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
                    }
                },
                validation: function validation() {
                    _logger.$logger.info('WPS_guest_upgrade_failed_SERVICE_VALIDATION_ERROR');
                    return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
                }
            });
        }
    }
});


_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_index.$GuestUpgradeModel;

_directive.$NationalIdModel;

_index2.$FreeReturnShippingOptInModel;

_logger.$logger;

_uiRouter.$state;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest-upgrade-interstitial/directive.js
// module id = ./components/xo-guest-components/src/guest-upgrade-interstitial/directive.js
// module chunks = 1